var _path, _line, _line2, _line3, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _line4, _line5, _line6, _line7, _rect5, _circle, _path5, _path6, _circle2, _circle3, _line8, _line9, _line10, _line11, _line12, _line13, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _rect6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 650 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dbe8ec",
    d: "M608.90415,226.12668V207.93552a13.07945,13.07945,0,0,0-13.07945-13.07945h-46.166a13.07945,13.07945,0,0,1-13.07946-13.07945V163.58545A13.07945,13.07945,0,0,1,549.65869,150.506h1.45764a13.07945,13.07945,0,0,0,13.07945-13.07945V119.23539a13.07945,13.07945,0,0,0-13.07945-13.07945H129.20918a13.07945,13.07945,0,0,0-13.07945,13.07945v18.19116A13.07945,13.07945,0,0,0,129.20918,150.506h0a13.07945,13.07945,0,0,1,13.07945,13.07945v18.19117a13.07945,13.07945,0,0,1-13.07945,13.07945H78.6298a13.07945,13.07945,0,0,0-13.07945,13.07945v18.19116A13.07945,13.07945,0,0,0,78.6298,239.20613H98.47638a13.07945,13.07945,0,0,1,13.07945,13.07946v18.19124a13.07945,13.07945,0,0,1-13.07945,13.07946h-.048A13.07945,13.07945,0,0,0,85.349,296.63574v18.19107a13.07945,13.07945,0,0,0,13.07945,13.07946h2.87139a13.07945,13.07945,0,0,1,13.07945,13.07945V359.177a13.07945,13.07945,0,0,1-13.07945,13.07945H54.1753a13.07945,13.07945,0,0,0-13.07945,13.07945V403.527A13.07945,13.07945,0,0,0,54.1753,416.60648h503.963A13.07945,13.07945,0,0,0,571.21777,403.527V385.33587a13.07945,13.07945,0,0,0-13.07945-13.07945H546.79779A13.07945,13.07945,0,0,1,533.71834,359.177V340.98572a13.07945,13.07945,0,0,1,13.07945-13.07945h26.73986a13.07945,13.07945,0,0,0,13.07945-13.07946V296.63574a13.07945,13.07945,0,0,0-13.07945-13.07945H565.426a13.07945,13.07945,0,0,1-13.07945-13.07946V252.28559A13.07945,13.07945,0,0,1,565.426,239.20613H595.8247A13.07945,13.07945,0,0,0,608.90415,226.12668Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 456.233,
    x2: 488.536,
    y1: 237.525,
    y2: 237.525,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 456.233,
    x2: 488.536,
    y1: 246.835,
    y2: 246.835,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 456.233,
    x2: 488.536,
    y1: 256.146,
    y2: 256.146,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 284.04,
    height: 220.32,
    x: 131.464,
    y: 158.486,
    fill: "#3086a3",
    rx: 13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 242.269,
    height: 178.92,
    x: 152.35,
    y: 179.186,
    fill: "#409cb5",
    rx: 8.997
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 65.32,
    height: 48.24,
    x: 181.064,
    y: 204.206,
    fill: "#dbe8ec",
    rx: 6.16
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 65.32,
    height: 48.24,
    x: 304.364,
    y: 287.006,
    fill: "#dbe8ec",
    rx: 6.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dbe8ec",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M311.46428,254.96648v10.94a8.86,8.86,0,0,1-8.86,8.86h-97.12a8.86,8.86,0,0,0-8.86,8.86v0a8.86,8.86,0,0,0,8.86,8.86h43.48a8.86,8.86,0,0,1,8.86,8.86v.92a8.86,8.86,0,0,0,8.86,8.86h37.67994"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#409cb5",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M415.50428,271.28648h23.48a8.86,8.86,0,0,1,8.86,8.86v.92a8.86,8.86,0,0,0,8.86,8.86h17.67994"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dbe8ec",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M246.38434,225.44648h56.21994a8.86,8.86,0,0,1,8.86,8.86v8.06"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 304.364,
    x2: 318.304,
    y1: 242.366,
    y2: 242.366,
    fill: "none",
    stroke: "#dbe8ec",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 304.364,
    x2: 318.304,
    y1: 254.966,
    y2: 254.966,
    fill: "none",
    stroke: "#dbe8ec",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 487.851,
    x2: 497.824,
    y1: 294.046,
    y2: 294.046,
    fill: "none",
    stroke: "#409cb5",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 487.851,
    x2: 497.824,
    y1: 284.046,
    y2: 284.046,
    fill: "none",
    stroke: "#409cb5",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 59.52,
    height: 77.04,
    x: 505.224,
    y: 249.686,
    fill: "#f9ae2b",
    rx: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 534.024,
    cy: 286.646,
    r: 12.24,
    fill: "#409cb5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3086a3",
    d: "M539.695,275.80494a12.22821,12.22821,0,0,1-14.70159,19.083,12.23178,12.23178,0,1,0,14.70159-19.083Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#409cb5",
    d: "M322.996 416.60648H223.97258a2 2 0 01-1.37368-3.45362l2.60865-2.46517a43.86445 43.86445 0 0013.73673-31.88119v0h69.08v0A43.86444 43.86444 0 00321.761 410.68769l2.60865 2.46517A2 2 0 01322.996 416.60648zM483.66421 277.76648h4.18719a0 0 0 010 0v22.56a0 0 0 010 0h-4.18719a11.28 11.28 0 01-11.28-11.28v0a11.28 11.28 0 0111.28-11.28z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 539.097,
    cy: 286.646,
    r: 2.655,
    fill: "#dbe8ec"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.952,
    cy: 286.646,
    r: 2.655,
    fill: "#dbe8ec"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 58.411,
    x2: 90.714,
    y1: 364.871,
    y2: 364.871,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 58.411,
    x2: 90.714,
    y1: 374.181,
    y2: 374.181,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 58.411,
    x2: 90.714,
    y1: 383.492,
    y2: 383.492,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 308.849,
    x2: 341.151,
    y1: 119.521,
    y2: 119.521,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 308.849,
    x2: 341.151,
    y1: 128.831,
    y2: 128.831,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 308.849,
    x2: 341.151,
    y1: 138.142,
    y2: 138.142,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.146,
    cy: 140.607,
    r: 16.428,
    fill: "#b9d4db"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.812,
    cy: 107.112,
    r: 8.557,
    fill: "#b9d4db"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.807,
    cy: 112.112,
    r: 7.406,
    fill: "#b9d4db"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.863,
    cy: 104.915,
    r: 4.936,
    fill: "#b9d4db"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.599,
    cy: 131.858,
    r: 11.833,
    fill: "#b9d4db"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.971,
    cy: 187.123,
    r: 16.428,
    fill: "#b9d4db"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 482.2,
    cy: 195.22,
    r: 8.557,
    fill: "#b9d4db"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 482.2,
    cy: 160.581,
    r: 11.833,
    fill: "#b9d4db"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.784,
    cy: 390.878,
    r: 16.428,
    fill: "#b9d4db"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 489.197,
    cy: 407.306,
    r: 7.406,
    fill: "#b9d4db"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.118,
    cy: 379.045,
    r: 11.833,
    fill: "#b9d4db"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 415.504,
    cy: 163.722,
    r: 35.702,
    fill: "#f9ae2b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.719,
    height: 33.024,
    x: 413.645,
    y: 141.974,
    fill: "#409cb5",
    rx: 1.859
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#409cb5",
    d: "M415.50428,187.12349c4.48683,0,4.49426-6.97307,0-6.97307-4.48684,0-4.49427,6.97307,0,6.97307Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.97a7adc74c9a2a4b0b4fdbcc9421d9bd.svg";
export { ForwardRef as ReactComponent };